export default {
  feed: '/properties/feed',
  feedListingDetail: '/properties/search/listing-detail/:id',
};
